var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M12 4.6665V3.99984H8.66663V11.9998H9.33329C9.70148 11.9998 9.99996 12.2983 9.99996 12.6665C9.99996 13.0347 9.70148 13.3332 9.33329 13.3332H6.66663C6.29844 13.3332 5.99996 13.0347 5.99996 12.6665C5.99996 12.2983 6.29844 11.9998 6.66663 11.9998H7.33329V3.99984H3.99996V4.6665C3.99996 5.03469 3.70148 5.33317 3.33329 5.33317C2.9651 5.33317 2.66663 5.03469 2.66663 4.6665V3.33317C2.66663 2.96498 2.9651 2.6665 3.33329 2.6665H12.6666C13.0348 2.6665 13.3333 2.96498 13.3333 3.33317V4.6665C13.3333 5.03469 13.0348 5.33317 12.6666 5.33317C12.2984 5.33317 12 5.03469 12 4.6665Z",
      fill: "#00051D",
      "fill-opacity": "0.4549"
    }, null, -1)
  ]));
}
__name(render, "render");
const text = markRaw({ name: "custom-color-text", render });
export {
  text as default
};
//# sourceMappingURL=text.js.map
